import CreationToolFont from '../../../../types/font'
import CreationToolFontSize from '../../../../types/font-size'
import { generateCaptionCanvas } from '../../../artboard/utils'
import { ICapture, ISegment } from '../types'

const getSegmentCaptionWatermark = async (segment: ISegment, capture: ICapture): Promise<string> => {
    // segment already has watermark
    if (segment.editParams?.watermark) {
        return segment.editParams?.watermark
    }

    // segment has caption and style data on capture, but no watermark yet
    if (
        segment.caption &&
        capture.upload_metadata?.caption_position &&
        capture.upload_metadata?.caption_style &&
        capture.upload_metadata?.auto_caption
    ) {
        // generate a watermark for segment if caption exists but no watermark exists
        try {
            const position = capture.upload_metadata.caption_position
            const style = capture.upload_metadata.caption_style
            const captionCanvas = await generateCaptionCanvas(
                {
                    text: CreationToolFont.isAllCaps(style.font) ? segment.caption.toUpperCase() : segment.caption,
                    color: style.color,
                    strokeColor: style.strokeColor,
                    fontFamily: CreationToolFont.fontFamily(style.font),
                    fontWeight: CreationToolFont.fontWeight(style.font),
                    fontSize:
                        CreationToolFontSize.sizeBaseOnHeight(style.fontSize) *
                        CreationToolFont.scale(style.font) *
                        capture.height,
                },
                capture.width * 0.9
            )

            const canvas = document.createElement('canvas')
            const context = canvas.getContext('2d')

            canvas.width = capture.width
            canvas.height = capture.height

            context?.drawImage(
                captionCanvas,
                position.x - captionCanvas.width / 2,
                position.y - captionCanvas.height / 2
            )

            return canvas.toDataURL('image/png', 0.7)
        } catch (e) {}
    }

    return ''
}

export default getSegmentCaptionWatermark
